import {useApi} from "@contexts/hooks/api/useApi.ts";
import {IDataDto} from "@models/shared/IDataDto.ts";
import {ICreateProdutoDto} from "@models/produtos/produtosDto.ts";
import __produto_endpoints from "@components/produtos/endpoints/__produto_endpoints.ts";
import {IProdutoFilters} from "@models/produtos/IProdutoFilters.tsx";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {IGetProdutoFilters, ProdutoIncludable, ProdutoOrderable} from "@components/produtos/dto/IProdutosFilter.ts";
import {IOrder} from "@models/shared/IOrder.ts";

export function useProduto() {
    const {Get} = useApi()

    const importar = (data: IDataDto<ICreateProdutoDto[]>) => {
        return Get(__produto_endpoints['import-produtos'](data))
    }

    const getProdutos = (data: { filters: IProdutoFilters, pagination: IPagination }) => {
        return Get(__produto_endpoints['get-produtos'](data))
    }
    const getProdutosV2 = (data: IDataDto<IGetProdutoFilters | undefined, ProdutoIncludable | undefined, IOrder<ProdutoOrderable> | undefined>) => {
        return Get(__produto_endpoints['v2']['get-produtos'](data))
    }

	const createProduto = (produto: ICreateProdutoDto) => {
		return Get(__produto_endpoints.createProduto(produto))
	}

    return {
        importProdutos: importar,
	    createProduto: createProduto,
        getProdutos: getProdutos,
        getProdutosV2: getProdutosV2,
    }
}
